import { render } from "./CreateLeave.vue?vue&type=template&id=4bf28c6d"
import script from "./CreateLeave.vue?vue&type=script&lang=js"
export * from "./CreateLeave.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__